import React from 'react';
import PropTypes from 'prop-types';
import Validation from '../../Validation/Validation';
import TimePicker from '../../MUI/TimePicker';

const TimeInputWithValidation = ({ name, formProps, handleTimeChange, value, ...rest }) => (
  <Validation
    name={name}
    errors={formProps.errors}
    clearError={formProps.clearError}
  >
    <TimePicker onChange={handleTimeChange} value={value} {...rest} size="small" fullWidth />
  </Validation>
);

TimeInputWithValidation.propTypes = {
  name: PropTypes.string.isRequired,
  formProps: PropTypes.shape({
    errors: PropTypes.shape({}),
    clearError: PropTypes.func,
  }).isRequired,
  value: PropTypes.string,
  handleTimeChange: PropTypes.func.isRequired,
};

TimeInputWithValidation.defaultProps = {
  value: '',
};

export default TimeInputWithValidation;
